import { lazy, Suspense, useMemo } from 'react';
import { EChartsOption as ChartOptions } from 'echarts';
import { Skeleton } from '@material-ui/lab';
import { useTheme } from '@emotion/react';

import { LinearChartProps } from './LinearChart.types';
import { Container } from './LinearChart.styles';
import { createLinearChartOptions } from './createLinearChartOptions';

const Chart = lazy(() => import('echarts-for-react'));

export function LinearChart(props: LinearChartProps) {
  const theme = useTheme();

  const options = useMemo<ChartOptions>(() => {
    return createLinearChartOptions(props, theme);
  }, [props, theme]);

  return (
    <Container>
      <Suspense fallback={<Skeleton width="100%" height="5rem" />}>
        <Chart option={options} notMerge lazyUpdate />
      </Suspense>
    </Container>
  );
}
